import React, { useState } from "react";
import { TextField } from "@mui/material";
import TransitionsModal from "../Modal/AddCartModal";
import { Link } from "react-router-dom";

function getCorrectColor(tag) {
  if (!tag) return "transparent";
  if (tag === "Nuevo") return "#d32f2f"; // Rojo
  if (tag === "Insignia") return "#1976d2"; // Azul
  if (tag.endsWith("%")) return "#2e7d32"; // Verde
  return "#757575"; // Gris por defecto
}

function getProductPageLink(product_id, product_name) {
  const encodedProductName = encodeURIComponent(product_name);
  return `/products/${product_id}-${encodedProductName}`;
}

function CardItem(props) {
  const [quantity, setQuantity] = useState(0);
  const tagColorType = getCorrectColor(props.tag);
  const productPage = getProductPageLink(props.id, props.product);

  const handleChangeQuantity = (event) => {
    const value = parseInt(event.target.value, 10);
    if (value < 0) setQuantity(0);
    else if (value <= maxQuantity) setQuantity(value);
  };

  const maxQuantity = parseInt(props.available);
  const outOfStock = !maxQuantity || maxQuantity <= 0;

  return (
    <li className="cards__item">
      <div className="cards__item__link">
        <div style={{ position: "relative", width: "100%" }}>
          {props.tag && (
            <div
              style={{
                position: "absolute",
                top: "10px",
                left: "10px",
                backgroundColor: tagColorType,
                color: "#ffffff",
                padding: "5px 10px",
                borderRadius: "3px",
                fontSize: "11px",
                fontWeight: "700",
                letterSpacing: "0.03em",
                textTransform: "uppercase",
                zIndex: 2,
              }}
            >
              {props.tag}
            </div>
          )}
          <Link to={productPage}>
            <figure className="cards__item__pic-wrap">
              <img
                className="cards__item__img"
                src={props.src}
                alt={props.product}
              />
            </figure>
          </Link>
        </div>
        <div className="cards__item__info">
          <h5 className="cards_product">{props.product}</h5>
          <h5 className="cards_price">{props.price}</h5>

          <div className="cards__item__actions">
            <span className="cards__item__quantity-label">Cant.</span>
            <TextField
              id="outlined-number"
              type="number"
              size="small"
              value={quantity}
              onChange={handleChangeQuantity}
              inputProps={{ min: 0, max: maxQuantity }}
              sx={{
                width: "64px",
                "& .MuiOutlinedInput-root": {
                  color: "#f2f2f2",
                  fontSize: "13px",
                  "& fieldset": { borderColor: "rgba(255,255,255,0.18)" },
                  "&:hover fieldset": { borderColor: "rgba(255,255,255,0.35)" },
                  "&.Mui-focused fieldset": { borderColor: "#faad2b" },
                },
              }}
            />
            <TransitionsModal
              id={props.id}
              product={props.product}
              price={props.price}
              quantity={quantity}
            />
          </div>

          <div className="cards__item__available">
            Disponibles: {props.available}
          </div>
        </div>
      </div>
    </li>
  );
}

export default CardItem;
